// extracted by mini-css-extract-plugin
module.exports = {"container":"News_container__3Q5eh","card":"News_card__N289_","newsCard":"News_newsCard__kYlwl","cardImage":"News_cardImage__1R8v4"};